import { useState, useEffect } from 'react'
import { SurveyProvider, useSurvey } from './context/SurveyContext'
import Logo from './components/UI/Logo'
import SurveyContainer from './components/Survey/SurveyContainer'
import PreSurveyBoostersContainer from './components/PreSurveyBoosters/PreSurveyBoostersContainer'
import ConversionBoosterContainer from './components/ConversionBooster/ConversionBoosterContainer'

function AppContent() {
  const [showPreBoosters, setShowPreBoosters] = useState(true);
  const [showSurvey, setShowSurvey] = useState(false);
  const [showPostBoosters, setShowPostBoosters] = useState(false);
  const { product, setCheckoutUrl, setCurrentPage } = useSurvey();

  // Check for skip parameter and preview mode on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const skipPreBoosters = urlParams.get('skip') === 'pre-boosters';
    const previewMode = urlParams.get('preview');

    // Skip pre-boosters if requested
    if (skipPreBoosters) {
      setShowPreBoosters(false);
      setShowSurvey(true);
    }

    // Preview mode for post-survey boosters
    if (previewMode === 'boosters' && product) {
      setCheckoutUrl('https://checkout.example.com/mock-checkout');
      setShowPreBoosters(false);
      setShowSurvey(false);
      setShowPostBoosters(true);
      console.log('🎨 Preview mode: Showing conversion boosters for', product.name);
    }
  }, [product, setCheckoutUrl]);

  const handlePreBoostersComplete = () => {
    setShowPreBoosters(false);
    setShowSurvey(true);
    // Reset progress to start of medical survey
    setCurrentPage(1);
  };

  const handleSurveyComplete = () => {
    setShowSurvey(false);
    setShowPostBoosters(true);
  };

  // Show pre-survey boosters first
  if (showPreBoosters) {
    return <PreSurveyBoostersContainer onComplete={handlePreBoostersComplete} />;
  }

  // Show main survey
  if (showSurvey) {
    return (
      <div className="min-h-screen bg-warm-beige">
        <div className="container mx-auto px-4 py-8">
          <Logo className="mb-8" />
          <SurveyContainer onComplete={handleSurveyComplete} />
        </div>
      </div>
    );
  }

  // Show post-survey boosters
  if (showPostBoosters) {
    return <ConversionBoosterContainer />;
  }

  return null;
}

function App() {
  return (
    <SurveyProvider>
      <AppContent />
    </SurveyProvider>
  )
}

export default App
